// 引入element-plus
import ElementPlus from 'element-plus'
// 引入自定义样式
// import 'element-plus/dist/index.css'

import './element-variables.scss' // 会导入element-plus的所有样式
import './element-ui.scss' // 注意在element-variables后面导入, 以覆盖默认element-plus的样式

// 引入语言配置
import zhCn from 'element-plus/es/locale/lang/zh-cn'

// 引入element-plugin-icon
import * as ElementPlusIconsVue from '@element-plus/icons-vue'

export const setupElementPlus = (app) => {
  app.use(ElementPlus, { size: 'default', locale: zhCn })

  for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
  }
}
